export default __webpack_public_path__ + "static/media/linkedin-ico.fd52e68a.svg";